import { forwardRef, memo } from 'react'
import Input from './Input'
import { FIGMA_INPUT_SHELL_CLASS } from './inputStyles'

function profileInitial(name) {
  const value = String(name || 'Пользователь').trim()
  return (value.charAt(0) || '?').toUpperCase()
}

const RecipientInput = forwardRef(function RecipientInput({
  profile = null,
  username = '',
  value = '',
  onChange,
  onButtonClick,
  buttonLabel,
  locked = false,
  placeholder = 'Введите @username',
  loading = false,
  className = '',
  ...props
}, ref) {
  const displayName = profile?.name || username || 'Пользователь'
  const displayUsername = username ? `@${username}` : ''
  const isLocked = Boolean(locked || profile || loading)
  const resolvedButtonLabel = buttonLabel || (isLocked ? 'Изменить' : 'Себе')

  return (
    <div className={`${FIGMA_INPUT_SHELL_CLASS} px-3 ${className}`}>
      {isLocked ? (
        <div className="pointer-events-none flex min-w-0 flex-1 items-center gap-3">
          {loading && !profile ? (
            <>
              <div className="h-9 w-9 shrink-0 animate-pulse rounded-full bg-[var(--figma-surface-10)]" />
              <div className="min-w-0 flex-1 space-y-1.5">
                <div className="h-3 w-28 animate-pulse rounded bg-[var(--figma-surface-10)]" />
                <div className="h-2.5 w-20 animate-pulse rounded bg-[var(--figma-surface-10)]" />
              </div>
            </>
          ) : (
            <>
              {profile?.avatar ? (
                <img
                  src={profile.avatar}
                  alt=""
                  loading="eager"
                  decoding="async"
                  className="h-9 w-9 shrink-0 rounded-full object-cover"
                />
              ) : (
                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[var(--figma-accent-bg)] text-sm font-[590] text-[var(--figma-accent-text)]">
                  {profileInitial(displayName)}
                </div>
              )}
              <div className="min-w-0 text-left">
                <p className="truncate text-[14px] font-[590] leading-4 tracking-[-0.01em] text-[var(--figma-text)]">{displayName}</p>
                {displayUsername ? (
                  <p className="truncate text-[12px] font-[510] leading-[14px] tracking-[-0.01em] text-[var(--figma-text-50)]">{displayUsername}</p>
                ) : null}
              </div>
            </>
          )}
        </div>
      ) : (
        <Input
          ref={ref}
          type="text"
          value={value}
          onChange={onChange}
          aria-label="Получатель"
          placeholder={placeholder}
          variant="unstyled"
          className="min-w-0 flex-1 bg-transparent px-1 text-[16px] font-[400] leading-[22px] tracking-[-0.01em] text-[var(--figma-text)] placeholder:text-[var(--figma-text-50)] focus:outline-none"
          {...props}
        />
      )}

      {isLocked ? (
        <Input
          ref={ref}
          type="text"
          value={value}
          readOnly
          aria-label="Получатель"
          aria-readonly="true"
          tabIndex={-1}
          variant="unstyled"
          className="pointer-events-none absolute inset-0 z-0 h-full w-full cursor-default rounded-[999px] bg-transparent px-3 pr-[88px] text-transparent caret-transparent focus:outline-none"
          {...props}
        />
      ) : null}

      <button
        type="button"
        onClick={(event) => {
          event.currentTarget.blur()
          onButtonClick?.(event)
        }}
        className="relative z-[1] inline-flex h-8 shrink-0 items-center justify-center rounded-[999px] border border-[var(--figma-text-50)] bg-[var(--figma-accent)] px-3 text-[14px] font-[510] leading-5 tracking-[-0.01em] text-[var(--figma-text)] outline-none transition-transform duration-[160ms] active:scale-[0.96] focus:outline-none focus:ring-0 focus-visible:outline-none"
      >
        {resolvedButtonLabel}
      </button>
    </div>
  )
})

RecipientInput.displayName = 'RecipientInput'

export default memo(RecipientInput)
